<template>
  <div class="main-content">
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MainContent',
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
@import "~@/styles/mixin.scss";

.main-content {
  margin-top: 50px;
  position: absolute;
  left: calc(#{$padding-page} + #{$sidebarWidth});
  top: 0;
  right: 0;
  bottom: 0;
  @include scrollBar;
  transition: all 0.5s;
  overflow: auto;
}
</style>
